// programType as the Check Recon list query returns it (taxCR.helper.js). Batch-paid
// MTG / MISC checks come back as the *AdditionalCollection variant of their receipt's
// program rather than mtgTransaction / miscTransaction.
const PROGRAM_TYPE_LABELS = {
  taxPayments: 'TAX',
  mtgTransaction: 'MTG',
  mtgAdditionalCollection: 'MTG',
  miscTransaction: 'MISC',
  miscAdditionalCollection: 'MISC',
};

export const programTypeLabel = (programType) => (
  Object.prototype.hasOwnProperty.call(PROGRAM_TYPE_LABELS, programType)
    ? PROGRAM_TYPE_LABELS[programType]
    : ''
);

export default {};
